import { Component, OnInit, Input } from "@angular/core";
import {
  Dialog,
  SharedModule,
  DataService,
  NotificationService,
  Asset,
} from "@bb-vendure/admin-ui/core";
import {
  FormBuilder,
  UntypedFormGroup,
  FormArray,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { concat, Observable, of, Subject } from "rxjs";
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  switchMap,
  tap,
  startWith,
} from "rxjs/operators";
import {
  FetchSupplierDocument,
  FetchSuppliersDocument,
  FetchShopSuppliersDocument,
  GetProductShopSupplierDocument,
  SortOrder,
  FetchRetailersDocument,
} from "../../generated-graphql/graphql";
import { ImageSelectorComponent } from "../images-selector/image-selector.component";

export interface Supplier {
  id: string;
  name: string;
}

interface SelectedAssets {
  assets?: Asset[];
  featuredAsset?: Asset;
}

@Component({
  imports: [SharedModule, ImageSelectorComponent],
  standalone: true,
  selector: "approve-dialog",
  templateUrl: "./approve-dialog.component.html",
})
export class ApproveRequestDialogComponent implements Dialog<any>, OnInit {
  resolveWith: (result?: any) => void;
  nextStates: string[] = [];
  message = "";
  cancellable: boolean = true;
  error = "";
  isLoading = false;
  isLoadingRetailer = false;

  @Input() selectedGroup: any[] = [];

  requestList: Map<string, UntypedFormGroup> = new Map();
  requestForm: FormArray;
  today = new Date().toISOString().substring(0, 10);

  suppliers$: Observable<Supplier[]>;
  retailers$: Observable<Supplier[]>;
  input$ = new Subject<string>();
  inputRetailer$ = new Subject<string>();
  selectedSupplier: Supplier;

  requestPurchase: FormArray;

  assetChanges: SelectedAssets[] = [];

  constructor(
    private formBuilder: FormBuilder,
    private dataService: DataService,
    private notificationService: NotificationService
  ) {}

  Requests(groupForm: UntypedFormGroup) {
    return groupForm.get("requests") as FormArray;
  }

  ngOnInit(): void {
    this.requestForm = this.formBuilder.array([]);
    for (const group of this.selectedGroup) {
      const groupForm = this.formBuilder.group({
        note: [group.note ?? ""],
        expectedDate: [
          group.expectedDate ? group.expectedDate.substring(0, 10) : null
        ],
        supplier: [group.shopSupplier ?? null, Validators.required],
        retailer: [group.retailer ?? null, Validators.required],
        requests: this.formBuilder.array([]),
        name: group.product.name,
        id: group.id,
        images: [null,Validators.required],
        imageIds: [],
      });

      for (const variant of group.requests) {
        this.Requests(groupForm).push(
          this.formBuilder.group({
            id: variant.id,
            productVariant: new FormControl(variant.productVariant.name),
            sku: new FormControl(variant.productVariant.sku),
            orderQuantity: new FormControl(variant.orderQuantity),
            stockOnHand: new FormControl(variant.stockOnHand),
            quantity: new FormControl(variant.quantityNeeded),
            quantityNeeded: variant.quantityNeeded,
            expectedDate: new FormControl(
              variant.expectedDate
                ? variant.expectedDate.substring(0, 10)
                : null,Validators.required
            ),
            note: new FormControl(),
          })
        );
      }

      this.requestForm.push(groupForm);
    }

    this.suppliers$ = concat(
      this.dataService
        .query(FetchShopSuppliersDocument, {
          options: {
            take: 5,
            sort: {
              createdAt: SortOrder.Desc,
            },
          },
        })
        .mapSingle(({ shopSuppliers }) => shopSuppliers?.items ?? []),
      this.input$.pipe(
        debounceTime(200),
        distinctUntilChanged(),
        tap(() => (this.isLoading = true)),
        switchMap((term) =>
          this.dataService
            .query(FetchShopSuppliersDocument, {
              options: {
                filter: {
                  name: {
                    contains: term,
                  },
                },
              },
            })
            .mapStream(({ shopSuppliers }) => shopSuppliers.items)
            .pipe(
              catchError(() => of([])),
              tap(() => (this.isLoading = false))
            )
        )
      )
    );
    this.retailers$ = concat(
      this.dataService
        .query(FetchRetailersDocument, {
          options: {
            take: 5,
            sort: {
              createdAt: SortOrder.Desc,
            },
          },
        })
        .mapSingle(({ retails }) => retails?.items ?? []),
      this.input$.pipe(
        debounceTime(200),
        distinctUntilChanged(),
        tap(() => (this.isLoading = true)),
        switchMap((term) =>
          this.dataService
            .query(FetchRetailersDocument, {
              options: {
                filter: {
                  name: {
                    contains: term,
                  },
                },
              },
            })
            .mapStream(({ retails }) => retails.items)
            .pipe(
              catchError(() => of([])),
              tap(() => (this.isLoadingRetailer = false))
            )
        )
      )
    );

    console.log(this.requestForm);
  }

  select() {
    for (const groupForm of this.requestForm.controls) {
      const value = groupForm.value;

      if (!value.supplier) {
        this.notificationService.error(`(${value.name}) Supplier is required`);
        return;
      }

      if (!value.retailer) {
        this.notificationService.error(`(${value.name}) Retailer is required`);
        return;
      }

    



      for (const variantForm of this.Requests(groupForm as UntypedFormGroup)
        .controls) {
        if (variantForm.value.quantity < variantForm.value.quantityNeeded) {
          this.notificationService.error(
            `(${variantForm.value.productVariant}) The quantity should be more than or equal to quantity needed : ${variantForm.value.quantityNeeded}`
          );
          return;
        }

        variantForm.patchValue({
          //expectedDate: groupForm.value.expectedDate,
          note: groupForm.value.note ?? "",
          //supplier: groupForm.value.supplier,
        });
      }

      groupForm.patchValue({
        imageIds:
          groupForm.value.images.assets &&
          groupForm.value.images.assets.length > 0
            ? groupForm.value.images.assets.map((a) => a.id)
            : null,
      });
    }

    console.log("request", this.requestForm.value);

    this.resolveWith({
      ...this.requestForm.value,
    });
  }

  cancel() {
    this.resolveWith();
  }

  trackByFn(item: Supplier) {
    return item.id;
  }

  onAssetChange($event: any) {
    console.log($event)
  }
}
